import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import TooltipMUI from 'components/styled/TooltipMUI'
import { Box } from '@mui/material'
import { LARGE_RADIUS } from 'utils/constants/Theme'
import HelpRoundedIcon from '@mui/icons-material/HelpRounded'

const HelpParameter = ({
    image,
}) => image && (
    <TooltipMUI
        title={(
            <Box sx={{ '& img': { width: 'auto', height: '40vh', borderRadius: LARGE_RADIUS } }}>
                <img src={image} alt={i18n.imageOfSetting} />
            </Box>
        )}
        placement='right'
        sx={{ borderRadius: LARGE_RADIUS, padding: 0.5 }}
    >
        <HelpRoundedIcon />
    </TooltipMUI>
)

HelpParameter.propTypes = {
    image: PropTypes.string,
}

export default HelpParameter
